/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

export default baseLt;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseLt.js
// module id = 538
// module chunks = 41